@switch (emptyState) {
  @case (EmptyStateKind.NoFlowsWithAccess) {
    <rt-empty-state
      [icon]="'warning'"
      [title]="'app.requisitions.list.empty_states.no_flow_created_with_access.title' | translate"
      [desc]="
        'app.requisitions.list.empty_states.no_flow_created_with_access.description' | translate
      "
    >
      <ng-container *ngTemplateOutlet="settingsButton"></ng-container>
    </rt-empty-state>
  }

  @case (EmptyStateKind.NoFlowsWithoutAccess) {
    <rt-empty-state
      [icon]="'assignment-turned-in'"
      [title]="'app.requisitions.list.empty_states.no_flow_created_no_access.title' | translate"
      [desc]="
        'app.requisitions.list.empty_states.no_flow_created_no_access.description' | translate
      "
    >
    </rt-empty-state>
  }

  @case (EmptyStateKind.NoDefaultFlowWithAccess) {
    <rt-empty-state
      [icon]="'warning'"
      [title]="'app.requisitions.list.empty_states.no_default_flow_with_access.title' | translate"
      [desc]="
        'app.requisitions.list.empty_states.no_default_flow_with_access.description' | translate
      "
    >
      <ng-container *ngTemplateOutlet="settingsButton"></ng-container>
    </rt-empty-state>
  }

  @case (EmptyStateKind.NoDefaultFlowWithoutAccess) {
    <rt-empty-state
      [icon]="'warning'"
      [title]="'app.requisitions.list.empty_states.no_default_flow_no_access.title' | translate"
      [desc]="
        'app.requisitions.list.empty_states.no_default_flow_no_access.description' | translate
      "
    >
    </rt-empty-state>
  }

  @case (EmptyStateKind.NoActiveRequisitionsWithAccess) {
    <rt-empty-state
      [icon]="'assignment-turned-in'"
      [title]="
        'app.requisitions.list.empty_states.no_active_requisitions_with_access.title' | translate
      "
      [desc]="
        'app.requisitions.list.empty_states.no_active_requisitions_with_access.description'
          | translate
      "
    >
      <rt-button variant="primary" (click)="newRequisition.emit()">
        <rt-icon name="add"></rt-icon>
        {{ 'app.requisitions.new_requisition' | translate }}
      </rt-button>
    </rt-empty-state>
  }

  @case (EmptyStateKind.NoActiveRequisitionsWithoutAccess) {
    <rt-empty-state
      [icon]="'assignment-turned-in'"
      [title]="
        'app.requisitions.list.empty_states.no_active_requisitions_no_access.title' | translate
      "
      [desc]="
        'app.requisitions.list.empty_states.no_active_requisitions_no_access.description'
          | translate
      "
    >
    </rt-empty-state>
  }
  @case (EmptyStateKind.NoNeedMyApprovalRequisitions) {
    <rt-empty-state
      [icon]="'assignment'"
      [title]="
        'app.requisitions.list.empty_states.no_need_my_approval_requisitions.title' | translate
      "
      [desc]="
        'app.requisitions.list.empty_states.no_need_my_approval_requisitions.description'
          | translate
      "
    >
    </rt-empty-state>
  }
  @case (EmptyStateKind.NoRequestedByMeRequsitions) {
    <rt-empty-state
      [icon]="'assignment'"
      [title]="
        'app.requisitions.list.empty_states.no_requested_be_me_requisitions.title' | translate
      "
      [desc]="
        'app.requisitions.list.empty_states.no_requested_be_me_requisitions.description' | translate
      "
    >
    </rt-empty-state>
  }
  @case (EmptyStateKind.NoArchivedRequisitions) {
    <rt-empty-state
      [icon]="'archive'"
      [title]="'app.requisitions.list.empty_states.no_archived_requisitions.title' | translate"
      [desc]="'app.requisitions.list.empty_states.no_archived_requisitions.description' | translate"
    >
    </rt-empty-state>
  }
  @case (EmptyStateKind.NoRequisitionsFound) {
    <rt-empty-state
      [icon]="'search'"
      [title]="'app.requisitions.list.empty_states.no_requisitions_found.title' | translate"
      [desc]="'app.requisitions.list.empty_states.no_requisitions_found.description' | translate"
    >
    </rt-empty-state>
  }
}

<ng-template #settingsButton>
  <rt-button (click)="openSettings()">
    {{ 'app.requisitions.list.empty_states.go_to_settings' | translate }}
  </rt-button>
</ng-template>
